import { __decorate, __metadata } from "tslib";
import { singleton } from 'tsyringe';
export class MicrofrontendEvent {
}
export class EventEmitter {
    constructor() {
        this.listener = new Map();
    }
    emit(event) {
        this.listener.forEach((functions, key) => {
            if (event instanceof key) {
                functions.forEach((func) => func(event));
            }
        });
    }
    removeListener(EventClass, fn) {
        this.listener.forEach((functions, key) => {
            if (EventClass === key) {
                this.listener.set(key, functions.filter((func) => {
                    return func !== fn;
                }));
            }
        });
    }
    removeAllListeners() {
        this.listener.forEach((_, key) => {
            this.listener.set(key, []);
        });
    }
    on(EventClass, fn) {
        const functions = this.listener.get(EventClass) || [];
        functions.push(fn);
        this.listener.set(EventClass, functions);
    }
}
let EventBus = class EventBus {
    constructor() {
        this.eventEmitter = new EventEmitter();
    }
    emit(event) {
        this.eventEmitter.emit(event);
    }
    removeListener(event, listener) {
        this.eventEmitter.removeListener(event, listener);
    }
    removeAllListener() {
        this.eventEmitter.removeAllListeners();
    }
    on(EventConstructor, listener) {
        this.eventEmitter.on(EventConstructor, listener);
    }
};
EventBus = __decorate([
    singleton(),
    __metadata("design:paramtypes", [])
], EventBus);
export { EventBus };
